import React from 'react';
import {
  BUSINESS_INFO,
  hasIncompleteLegalBusinessInfo,
  LEGAL_LAST_UPDATED_LABEL,
  LEGAL_TEXT_VERSION
} from '../lib/legal-config';

const SHIPPING_ROWS = [
  { weight: '1g - 2kg', price: '5,43 EUR' },
  { weight: '2,001kg - 5kg', price: '6,21 EUR' },
  { weight: '5,001kg - 10kg', price: '7,94 EUR' },
  { weight: '10,001kg - 20kg', price: '9,51 EUR' },
  { weight: '20,001kg - 30kg', price: '12,01 EUR' },
  { weight: '30,001kg - 50kg', price: '17,59 EUR' },
  { weight: '50,001kg - 70kg', price: '19,60 EUR' },
  { weight: '70,001kg - 100kg', price: '24,50 EUR' }
];

function LegalWarning() {
  if (!hasIncompleteLegalBusinessInfo()) {
    return null;
  }

  return (
    <p className="legal-warning">
      Attenzione: alcuni dati aziendali obbligatori sono placeholder e vanno completati prima del go-live.
    </p>
  );
}

const ShippingReturnsPage = () => {
  return (
    <section className="legal-page">
      <h2 className="shop-title">Spedizioni e Resi</h2>
      <p className="legal-meta">
        Versione: <strong>{LEGAL_TEXT_VERSION}</strong> | Ultimo aggiornamento: {LEGAL_LAST_UPDATED_LABEL}
      </p>
      <LegalWarning />

      <section className="legal-section">
        <h3>Area di consegna</h3>
        <p>Spediamo in Italia (isole incluse) all&apos;indirizzo indicato in checkout.</p>
      </section>

      <section className="legal-section">
        <h3>Costi spedizione per peso</h3>
        <div className="legal-table-wrap">
          <table className="legal-table">
            <thead>
              <tr>
                <th>Fascia peso ordine</th>
                <th>Costo spedizione</th>
              </tr>
            </thead>
            <tbody>
              {SHIPPING_ROWS.map((row) => (
                <tr key={row.weight}>
                  <td>{row.weight}</td>
                  <td>{row.price}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      <section className="legal-section">
        <h3>Tempi indicativi</h3>
        <p>
          Gli ordini vengono affidati al corriere entro <strong>10 giorni lavorativi</strong> dalla conferma del
          pagamento. I tempi effettivi di consegna possono variare in base a destinazione, periodo e operativita&apos; del
          corriere. Eventuali ritardi rilevanti saranno comunicati via email o telefono.
        </p>
      </section>

      <section className="legal-section">
        <h3>Resi e diritto di recesso</h3>
        <p>
          Se acquisti come consumatore, puoi esercitare il diritto di recesso entro 14 giorni dalla consegna, nei casi
          previsti dalla normativa. Restano ferme le eccezioni di legge (ad esempio beni deteriorabili o che rischiano
          di scadere rapidamente, beni confezionati su misura o beni sigillati aperti per motivi igienici/sanitari).
        </p>
        <p>
          Per richiedere recesso o assistenza post-vendita scrivi a {BUSINESS_INFO.email} indicando numero ordine e
          prodotti coinvolti. Le istruzioni operative verranno fornite via email.
        </p>
        <p>
          In caso di prodotto non conforme o danneggiato al ricevimento, contattaci tempestivamente allegando foto e
          descrizione del problema.
        </p>
      </section>
    </section>
  );
};

export default ShippingReturnsPage;
